export default class extends Controller {

  connect() {
    this.appendRowFromResponse = this.appendRowFromResponse.bind(this)
  }

  toggleExpandedRow(event) {
    event && event.preventDefault()
    this.isExpanded ? this.close() : App.Helpers.ajaxRequest({ url: this.url, successHandler: this.appendRowFromResponse })
  }

  close() {
    this.expandedRow.remove()
  }

  appendRowFromResponse(response) {
    this.expandedRow = response
  }

  //
  // GETTERS AND SETTERS
  //

  get url() {
    return this.data.get("expand-url")
  }

  get expandedRowClass() {
    return this.data.get("expanded-row-class")
  }

  get expandedRowSelector() {
    return `.${this.expandedRowClass}`
  }

  get row() {
    return this.element.closest("tr")
  }

  get table() {
    return this.element.closest("table")
  }

  get expandedRow() {
    return this.table.getElementsByClassName(this.expandedRowClass)[0]
  }

  set expandedRow(content) {
    if (content) {
      const responseRow = App.Helpers.selectHTMLFromString(content)[0]
      responseRow.classList.add(this.expandedRowClass)
      App.Helpers.appendAfter(responseRow, this.row)
    }
  }

  get isExpanded() {
    return !!this.expandedRow
  }
}



// WEBPACK FOOTER //
// ./app/components/controls/table_lists/assets/javascript/controls-table-lists-expand-collapse-row-link-controller.js